/* ═══════════════════════════════════════════════════════════════════════
   LA MINI-COURBE DES CARTES CHIFFRÉES

   108 × 40, reprise du modèle v3 au trait près : courbe lissée, aplat
   dégradé en dessous, point plein au dernier relevé.

   Elle ne porte ni axe ni valeur — c'est une forme, pas un graphique. Sa
   seule fonction est de dire « ça monte » ou « ça stagne » d'un coup
   d'œil, à côté d'un chiffre qui, lui, donne la valeur exacte.
   ═══════════════════════════════════════════════════════════════════════ */

/* Lissage de Catmull-Rom converti en Bézier cubique : chaque point tire
   ses poignées du milieu de ses deux voisins. Une polyligne brute
   donnerait des angles que le modèle n'a nulle part. */
function lisser(p) {
  let d = `M${p[0][0]},${p[0][1]}`;
  for (let i = 0; i < p.length - 1; i += 1) {
    const a = p[i - 1] || p[i];
    const b = p[i];
    const c = p[i + 1];
    const e = p[i + 2] || c;
    d += ` C${b[0] + (c[0] - a[0]) / 6},${b[1] + (c[1] - a[1]) / 6}`
       + ` ${c[0] - (e[0] - b[0]) / 6},${c[1] - (e[1] - b[1]) / 6}`
       + ` ${c[0]},${c[1]}`;
  }
  return d;
}

let compteur = 0;

export default function Miniligne({ donnees, couleur = '#5EBD4F', sombre = false }) {
  const valeurs = (donnees || []).filter((v) => Number.isFinite(Number(v))).map(Number);
  // Deux points au moins : une courbe d'un seul relevé ne dit rien, et la
  // division par l'amplitude serait une division par zéro.
  if (valeurs.length < 2) return null;

  const L = 108;
  const H = 40;
  const m = 4;
  const mn = Math.min(...valeurs);
  const mx = Math.max(...valeurs);
  const pts = valeurs.map((v, i) => [
    m + ((L - 2 * m) * i) / (valeurs.length - 1),
    m + (H - 2 * m) * (1 - (v - mn) / ((mx - mn) || 1)),
  ]);
  const d = lisser(pts);
  const fin = pts[pts.length - 1];
  compteur += 1;
  const id = `mini-${compteur}`;

  return (
    <svg width={L} height={H} viewBox={`0 0 ${L} ${H}`}
         className="block overflow-visible" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={couleur} stopOpacity={sombre ? 0.35 : 0.22} />
          <stop offset="100%" stopColor={couleur} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={`${d} L${fin[0]},${H} L${pts[0][0]},${H} Z`} fill={`url(#${id})`} />
      <path d={d} fill="none" stroke={couleur} strokeWidth="2" strokeLinecap="round" />
      <circle cx={fin[0]} cy={fin[1]} r="3.5"
              fill={sombre ? '#0B1620' : '#FFFFFF'} stroke={couleur} strokeWidth="2" />
    </svg>
  );
}
